angular.module('gc.ban-popin', ['gc.services'])
.directive('banPopin', [
  '$rootScope', '$window', '$timeout', 'CommentService', 'LocalStorageService',
  function ($rootScope, $window, $timeout, CommentService, LocalStorageService) {
  'use strict';

  return {
    restrict: 'E',
    replace: true,
    scope: {
      user: '=',
      callback: '&',
    },
    templateUrl: 'banPopin.html',
    link: function (scope, el, attrs) {
      scope.website = CommentService.website;
      scope.isGuest = !scope.user._id;
      scope.activeBanTab = LocalStorageService.getItem('ban-tab') || 'permanent-ban';
      scope.banData = typeof LocalStorageService.getItem('ban-data') === 'object'
        ? LocalStorageService.getItem('ban-data')
        : {
          account: true,
          email: scope.isGuest,
          reason_id: 0,
          date: {
            range: '1 day',
            custom: { count: '1', type: 'hour' },
          },
        };



      scope.close = function () {
        $rootScope.banPopinVisible = false;
        $rootScope.banPopinUser = null;
      };

      scope.overlayClick = function(event) {
        if (event.target.classList.contains('gc-popin-wrapper')) {
          scope.close();
        }
      };

      scope.submit = function () {
        if (scope.website.rights === 'free' && scope.activeBanTab !== 'permanent-ban') return;

        ['pseudo', 'email', 'ip', 'account'].forEach(function (type) {
          if (type === 'ip' && !scope.user.ip) return;
          if (type === 'account' && scope.isGuest) return;

          var element = type === 'account' ? null : scope.user[type];
          if (type === 'pseudo' && !element) element = scope.user.username;

          CommentService[(type === 'account' || scope.banData[type]) ? 'ban' : 'unban']({
            type,
            element,
            user: type === 'account' ? scope.user : null,
            reason: scope.banData.reason,
            reason_id: scope.banData.reason_id,
            hide_ban_message: scope.banData.hide_ban_message,
            permanent: scope.activeBanTab === 'permanent-ban',
            shadow: scope.activeBanTab === 'shadow-ban',
            date_start: scope.activeBanTab === 'temporary-ban' ? new Date() : null,
            date_end: scope.activeBanTab !== 'permanent-ban' ? getCustomEndDate() : null,
          }).then(function() {
            // run only once, when all calls are done
            if (type === 'account') {
              $timeout(function() {
                scope.close();
                scope.callback()();
              }, 1000);
            }
          });
        });
      };

      scope.setBanTab = function(tab) {
        scope.activeBanTab = tab;
        LocalStorageService.setItem('ban-tab', tab);
      };

      scope.$watch('banData', function() {
        var banData = angular.copy(scope.banData);
        banData.reason_id = 0;
        delete banData.reason;
        LocalStorageService.setItem('ban-data', banData);
      }, true);

      function getCustomEndDate() {
        var m = moment();

        switch (scope.banData.date.range) {
          case '1 day':
            m.add(1, 'day');
          break;
          case '1 week':
            m.add(1, 'week');
          break;
          case '2 weeks':
            m.add(2, 'weeks');
          break;
          case 'custom':
            m.add(scope.banData.date.custom.count, scope.banData.date.custom.type);
          break;
          case 'permanently':
            return null;
          default:
            throw `unknown date range ${scope.banData.date.range}`;
        }

        return m.toDate();
      }
    },
  };
}]);
